export default __webpack_public_path__ + "static/media/mod.fd52b929.svg";